import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c(VSkeletonLoader, { attrs: { type: "image" } })
        : _vm._e(),
      _vm.worksheetObj
        ? _c(
            VSheet,
            _vm._b({ attrs: { light: "" } }, "v-sheet", _vm.attrs, false),
            [
              _vm.errorMsg
                ? _c(
                    VAlert,
                    {
                      staticClass: "mx-2",
                      attrs: { dismissible: "", type: "warning" },
                      model: {
                        value: _vm.showMsg,
                        callback: function ($$v) {
                          _vm.showMsg = $$v
                        },
                        expression: "showMsg",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]
                  )
                : _vm._e(),
              _c(
                VCard,
                {
                  staticClass: "pb-5 ma-3",
                  attrs: {
                    loading: _vm.loading,
                    elevation: 2,
                    flat: "",
                    hover: "",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex pt-2",
                      staticStyle: { "background-color": "#eeeeee" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-caption font-weight-light mr-4" },
                        [
                          _vm.index
                            ? _c("span", { staticClass: "ml-2" }, [
                                _vm._v(_vm._s(_vm.index)),
                              ])
                            : _vm._e(),
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewQrCode(
                                    _vm.worksheetObj.dynamicQrCodeId
                                  )
                                },
                              },
                            },
                            [_c(VIcon, [_vm._v("mdi-qrcode")])],
                            1
                          ),
                          _vm._v(
                            " " + _vm._s(_vm.worksheetObj.worksheetType) + " "
                          ),
                          _vm.worksheetObj.processTypeName
                            ? _c("span", [
                                _vm._v(
                                  " / " +
                                    _vm._s(_vm.worksheetObj.processTypeName) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.worksheetObj && _vm.worksheetObj.processDirection
                            ? _c("span", [
                                _vm._v(
                                  " / " +
                                    _vm._s(
                                      _vm.worksheetObj.processDirection ==
                                        "Input"
                                        ? _vm.$vuetify.lang.t(
                                            "$vuetify.worksheet.in"
                                          )
                                        : _vm.$vuetify.lang.t(
                                            "$vuetify.worksheet.out"
                                          )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.worksheetObj && _vm.worksheetObj.supplierName
                            ? _c("span", [
                                _vm._v(
                                  " / " +
                                    _vm._s(_vm.worksheetObj.supplierName) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.worksheetObj && _vm.worksheetObj.customerName
                            ? _c("span", [
                                _vm._v(
                                  " / " +
                                    _vm._s(_vm.worksheetObj.customerName) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.worksheetObj && _vm.worksheetObj.productName
                            ? _c("span", [
                                _vm._v(
                                  " / " +
                                    _vm._s(_vm.worksheetObj.productName) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "ml-auto mr-2 my-auto font-weight-light",
                        },
                        [
                          _vm.worksheetObj &&
                          _vm.worksheetObj.processId &&
                          _vm.worksheetObj.status == "USED"
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: `${_vm.backofficeUrl}/factory/process/${_vm.worksheetObj.processId}`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.statusLang(
                                            _vm.worksheetObj.status
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm.worksheetObj &&
                              _vm.worksheetObj.purchaseId &&
                              _vm.worksheetObj.status == "USED"
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: `${_vm.backofficeUrl}/purchase/${_vm.worksheetObj.purchaseId}`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.statusLang(
                                            _vm.worksheetObj.status
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm.worksheetObj &&
                              _vm.worksheetObj.packingListId &&
                              _vm.worksheetObj.status == "USED"
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: `${_vm.backofficeUrl}/office/sales/order/${_vm.worksheetObj.salesOrderId}?view=detail#packagepanel`,
                                      title: `Packing List ${
                                        _vm.worksheetObj.packingListId
                                      }${
                                        _vm.worksheetObj.packagingCode
                                          ? " / " +
                                            _vm.worksheetObj.packagingCode
                                          : ""
                                      }`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.statusLang(
                                            _vm.worksheetObj.status
                                          )
                                        ) +
                                        " (PL " +
                                        _vm._s(_vm.worksheetObj.packingListId) +
                                        ") "
                                    ),
                                  ]
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statusLang(_vm.worksheetObj.status)
                                  )
                                ),
                              ]),
                        ]
                      ),
                    ]
                  ),
                  _vm.editLocation && _vm.locations && _vm.locations.length > 0
                    ? _c(
                        VCardActions,
                        { staticClass: "justify-space-between mx-2" },
                        [
                          _c(VAutocomplete, {
                            key: _vm.locations ? _vm.locations.length : 0,
                            staticClass: "mt-2",
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.worksheet.location"
                              ),
                              placeholder: _vm.$vuetify.lang.t(
                                "$vuetify.worksheet.chooseLocation"
                              ),
                              items: _vm.locations,
                              "item-text": "name",
                              "item-value": "id",
                              clearable: "",
                              solo: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.worksheet.locationId,
                              callback: function ($$v) {
                                _vm.$set(_vm.worksheet, "locationId", $$v)
                              },
                              expression: "worksheet.locationId",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "mt-4 mt-md-0" },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-4",
                                  attrs: { color: "primary" },
                                  on: { click: _vm.updateLocation },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.base.save"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-4",
                                  on: {
                                    click: function ($event) {
                                      _vm.editLocation = false
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.base.cancel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCardActions,
                    { staticClass: "justify-space-between" },
                    [
                      _c(
                        "div",
                        { staticClass: "text-caption font-weight-light mt-2" },
                        [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.label.id")
                                ) +
                                ": " +
                                _vm._s(_vm.worksheetObj.id) +
                                " "
                            ),
                            _vm.worksheetObj && _vm.worksheetObj.documentNumber
                              ? _c("span", [
                                  _vm._v(
                                    " / " +
                                      _vm._s(_vm.worksheetObj.documentNumber) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm.worksheetObj && _vm.worksheetObj.processTime
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatDateTimeYear")(
                                        _vm.worksheetObj.processTime
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          !_vm.editLocation
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    color: _vm.worksheetObj.locationName
                                      ? ""
                                      : "red",
                                    text: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.loadLocations()
                                      _vm.editLocation = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.worksheetObj.locationName
                                          ? _vm.worksheetObj.locationName
                                          : "No Location"
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.showEdit
                        ? _c(
                            VSpeedDial,
                            {
                              attrs: {
                                direction: "bottom",
                                "open-on-hover": false,
                                transition: "slide-y-transition",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function () {
                                      return [
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              color: "blue darken-2",
                                              dark: "",
                                              fab: "",
                                              small: "",
                                            },
                                            model: {
                                              value: _vm.actions,
                                              callback: function ($$v) {
                                                _vm.actions = $$v
                                              },
                                              expression: "actions",
                                            },
                                          },
                                          [
                                            _vm.actions
                                              ? _c(VIcon, [
                                                  _vm._v(" mdi-close "),
                                                ])
                                              : _c(VIcon, [
                                                  _vm._v(" mdi-dots-vertical "),
                                                ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                4291102951
                              ),
                              model: {
                                value: _vm.actions,
                                callback: function ($$v) {
                                  _vm.actions = $$v
                                },
                                expression: "actions",
                              },
                            },
                            [
                              _vm.editButtons.includes("edit") &&
                              _vm.worksheetObj.status != "USED"
                                ? _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "green",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "edit",
                                            _vm.worksheet
                                          )
                                        },
                                      },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-pencil")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm.editButtons.includes("print") && _vm.canPrint
                                ? _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        title: "Print Worksheet",
                                        color: "indigo",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "print",
                                            _vm.worksheet
                                          )
                                        },
                                      },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-printer")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm.editButtons.includes("save-packing-list") &&
                              _vm.worksheetObj.status == "SUBMITTED"
                                ? _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "indigo",
                                        title: "Save as Packing List",
                                      },
                                      on: { click: _vm.savePackingList },
                                    },
                                    [
                                      _c(VIcon, [
                                        _vm._v(
                                          "mdi-package-variant-closed-check"
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.worksheetObj &&
                              !_vm.submitted &&
                              _vm.editButtons.includes("delete")
                                ? _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "red",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "remove",
                                            _vm.worksheet
                                          )
                                        },
                                      },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-delete")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm.worksheetObj &&
                              !_vm.submitted &&
                              _vm.worksheetTypeFields.hasInventorySelection &&
                              _vm.hasInventoryEntries &&
                              _vm.isFifoOrLifo
                                ? _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "orange",
                                        title: _vm.$vuetify.lang.t(
                                          "$vuetify.worksheet.reassignAll"
                                        ),
                                      },
                                      on: { click: _vm.reassignAll },
                                    },
                                    [
                                      _c(VIcon, [
                                        _vm._v("mdi-swap-horizontal"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(VDivider, { staticClass: "my-0" }),
                  _c(VCardText, [
                    _vm.worksheetObj && _vm.worksheetObj.totalNetWeight != 0
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-space-between my-2" },
                          [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.weight")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "mx-5 text-right" },
                              [
                                _c(
                                  VRow,
                                  {
                                    staticStyle: { "min-width": "200px" },
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _vm.worksheetObj.targetWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.targetWeight"
                                              )
                                            ) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.worksheetObj &&
                                    _vm.worksheetObj.targetWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                _vm.worksheetObj.targetWeight
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.productInfo
                                                  ? _vm.productInfo
                                                      .measureWeight
                                                  : ""
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.sum && _vm.sum.grossWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.grossWeight"
                                              )
                                            ) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.sum && _vm.sum.grossWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                _vm.sum.grossWeight
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.productInfo
                                                  ? _vm.productInfo
                                                      .measureWeight
                                                  : ""
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.worksheetObj &&
                                    _vm.worksheetObj.deductibleWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.deductibleWeight"
                                              )
                                            ) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.worksheetObj &&
                                    _vm.worksheetObj.deductibleWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            " -" +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.sum
                                                    ? _vm.sum.deductibleWeight
                                                    : 0
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.productInfo
                                                  ? _vm.productInfo
                                                      .measureWeight
                                                  : ""
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.totalEntryAdjstmentWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.worksheet.totalEntryAdjustment"
                                              )
                                            ) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.totalEntryAdjstmentWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.totalEntryAdjstmentWeight > 0
                                                ? "+"
                                                : ""
                                            ) +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.totalEntryAdjstmentWeight
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.productInfo
                                                  ? _vm.productInfo
                                                      .measureWeight
                                                  : ""
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.worksheetObj &&
                                    _vm.worksheetObj.netAdjustmentWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.netAdjustmentWeight"
                                              )
                                            ) + ":"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.worksheetObj &&
                                    _vm.worksheetObj.netAdjustmentWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.worksheetObj
                                                .netAdjustmentWeight > 0
                                                ? "+"
                                                : ""
                                            ) +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.worksheetObj
                                                    .netAdjustmentWeight
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.productInfo
                                                  ? _vm.productInfo
                                                      .measureWeight
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.worksheetObj &&
                                    _vm.worksheetObj.totalNetWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.netWeight"
                                              )
                                            ) + ": "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.worksheetObj &&
                                    _vm.worksheetObj.totalNetWeight
                                      ? _c(VCol, { attrs: { cols: "6" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                _vm.worksheetObj.totalNetWeight
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.productInfo
                                                  ? _vm.productInfo
                                                      .measureWeight
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-space-between my-2" },
                      [
                        _c("div", { staticClass: "font-weight-bold my-auto" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.entries")
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "text-right" },
                          [
                            _c(
                              VChip,
                              {
                                staticClass: "mr-5 mb-2",
                                attrs: { outlined: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.entriesDialog = true
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.worksheetObj &&
                                        _vm.worksheetObj.entries
                                        ? _vm.groupedEntryCount(
                                            _vm.worksheetObj.entries
                                          )
                                        : 0
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.base.entries"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.worksheetObj &&
                            _vm.worksheetObj.entries &&
                            _vm.groupedEntryCount(_vm.worksheetObj.entries) > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mx-5 text-right text-caption",
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.sum ? _vm.sum.minWeight : 0
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.productInfo
                                              ? _vm.productInfo.measureWeight
                                              : ""
                                          ) +
                                          " (min); " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.sum ? _vm.sum.maxWeight : 0
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.productInfo
                                              ? _vm.productInfo.measureWeight
                                              : ""
                                          ) +
                                          " (max) "
                                      ),
                                    ]),
                                    _vm.sum
                                      ? _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  _vm.sum.minDate
                                                )
                                              ) +
                                              " -> " +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  _vm.sum.maxDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm.worksheetObj &&
                    _vm.worksheetObj.files &&
                    _vm.worksheetObj.files.length > 0
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-space-between my-2" },
                          [
                            _c(
                              "div",
                              { staticClass: "font-weight-bold my-auto" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.base.attachments"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "mr-2",
                                attrs: { text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.imgDialog = true
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.fileInput.counter",
                                      _vm.worksheetObj.files.length
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.worksheetObj && _vm.worksheetObj.vehiclePlateNumber
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-space-between my-2" },
                          [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.worksheet.plateNumber"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", { staticClass: "mx-5" }, [
                              _vm._v(
                                _vm._s(_vm.worksheetObj.vehiclePlateNumber)
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.worksheetObj && _vm.worksheetObj.notes
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-space-between my-2" },
                          [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.notes")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", { staticClass: "mx-5" }, [
                              _vm._v(_vm._s(_vm.worksheetObj.notes)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c("v-card-action", [
                    _c("div", { staticClass: "mx-4" }, [
                      _vm.worksheetObj && _vm.worksheetObj.memo
                        ? _c("div", { staticClass: "text-caption" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.memo")
                                ) +
                                ": "
                            ),
                            _c("span", { staticClass: "ml-4" }, [
                              _vm._v(_vm._s(_vm.worksheetObj.memo)),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-caption font-weight-thin text-right mt-5",
                        },
                        [
                          _vm.worksheetObj.submittedTime
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.base.submittedOn"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm._f("formatDateTime")(
                                        _vm.worksheetObj.submittedTime
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.createdOn")
                                ) +
                                " " +
                                _vm._s(
                                  _vm._f("formatDateTime")(
                                    _vm.worksheetObj.createTime
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.createdBy")
                                ) +
                                " " +
                                _vm._s(_vm.worksheetObj.staffName) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "absolute",
                            "margin-top": "-25px",
                          },
                        },
                        [
                          _vm.confirmedBy
                            ? _c(
                                VIcon,
                                {
                                  attrs: {
                                    title: _vm.confirmedBy,
                                    color: "green",
                                  },
                                },
                                [_vm._v(" mdi-check-decagram ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                VDialog,
                {
                  staticStyle: { "z-index": "1000" },
                  attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly },
                  model: {
                    value: _vm.entriesDialog,
                    callback: function ($$v) {
                      _vm.entriesDialog = $$v
                    },
                    expression: "entriesDialog",
                  },
                },
                [
                  _vm.worksheetObj
                    ? _c(
                        VCard,
                        [
                          _c(
                            VCardTitle,
                            { staticClass: "d-flex justify-space-between" },
                            [
                              _c("div", { staticClass: "text-subtitle-1" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.worksheet.worksheet"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.worksheetObj.id) +
                                    " "
                                ),
                                _vm.worksheetObj.documentNumber
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-caption font-weight-light",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.documentNumber"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(
                                              _vm.worksheetObj.documentNumber
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                VBtn,
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.entriesDialog = false
                                    },
                                  },
                                },
                                [_c(VIcon, [_vm._v("mdi-close")])],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VDivider),
                          _c(
                            VCardText,
                            [
                              _c("worksheet-items", {
                                attrs: {
                                  worksheet: _vm.worksheetObj,
                                  sum: _vm.sum,
                                  worksheetTypeFields: _vm.worksheetTypeFields,
                                  productInfo: _vm.productInfo,
                                  editable: false,
                                },
                                on: {
                                  "update:worksheet": function ($event) {
                                    _vm.worksheetObj = $event
                                  },
                                  "update:sum": function ($event) {
                                    _vm.sum = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                VDialog,
                {
                  staticStyle: { "z-index": "1000" },
                  attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly },
                  model: {
                    value: _vm.imgDialog,
                    callback: function ($$v) {
                      _vm.imgDialog = $$v
                    },
                    expression: "imgDialog",
                  },
                },
                [
                  _vm.worksheetObj
                    ? _c(
                        VCard,
                        [
                          _c(
                            VCardTitle,
                            { staticClass: "d-flex justify-space-between" },
                            [
                              _c("div", { staticClass: "text-subtitle-1" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.worksheet.worksheet"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.worksheetObj.id) +
                                    " "
                                ),
                                _vm.worksheetObj.documentNumber
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-caption font-weight-light",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.documentNumber"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(
                                              _vm.worksheetObj.documentNumber
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.worksheetObj &&
                                _vm.worksheetObj.deductibleWeight
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-caption font-weight-light",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.base.deductibleWeight"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                _vm.worksheetObj
                                                  .deductibleWeight
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.productInfo
                                                ? _vm.productInfo.measureWeight
                                                : ""
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                VBtn,
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.imgDialog = null
                                    },
                                  },
                                },
                                [_c(VIcon, [_vm._v("mdi-close")])],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCardText,
                            [
                              _vm.images && _vm.images.length > 0
                                ? _c(
                                    VCarousel,
                                    {
                                      attrs: {
                                        continuous: "",
                                        "hide-delimiter-background": "",
                                        height: "80vh",
                                      },
                                    },
                                    _vm._l(_vm.images, function (img, i) {
                                      return _c(
                                        VCarouselItem,
                                        {
                                          key: i,
                                          attrs: {
                                            "reverse-transition":
                                              "fade-transition",
                                            transition: "fade-transition",
                                          },
                                        },
                                        [
                                          _c(
                                            VContainer,
                                            {
                                              staticClass:
                                                "fill-height align-items-center justify-content-center",
                                            },
                                            [
                                              _c(
                                                VLayout,
                                                {
                                                  staticClass: "flex-column",
                                                  attrs: {
                                                    "justify-center": "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-caption mx-auto",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDateTime"
                                                            )(img.time)
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(VImg, {
                                                    attrs: {
                                                      contain: "",
                                                      "aspect-ratio": "1.7",
                                                      src: img.src,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-subtitle-2 font-weight-light",
                                    },
                                    [_vm._v(" No attachments found ")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }